import gql from 'graphql-tag';

const CREATE_PROJECT = gql`
  mutation($input: ProjectInput) {
    createProject(input: $input) {
      projectId
      displayId
      title
      status
      scheduledStartDate
      dueDate
      overdue
      actualStartDate
      actualEndDate
      showToClient
      client {
        accountId
        name
      }
      site {
        id
        name
      }
      owner {
        userId
        name
        email
      }
      members {
        user {
          userId
          name
          firstName
          lastName
          email
        }
        totalTasks
        completedTasks
      }
      milestones {
        milestoneId
        name
        status
        actualEndDate
        totalTasks
        plannedTasks
        inProgressTasks
        blockedTasks
        completedTasks
        overdueTasks
      }
      totalTasks
      plannedTasks
      inProgressTasks
      blockedTasks
      completedTasks
      overdueTasks
      totalMilestones
      completedMilestones
      loggedInUserRole {
        roleId
        name
        description
        roleType {
          name
        }
        editable
        creationType
        roleFeatureList {
          feature {
            featureId
            key
          }
          operationList {
            operationId
            name
            value
          }
        }
      }
    }
  }
`;

const UPDATE_SHOW_PROJECT_TO_CLIENT = gql`
  mutation($projectId: ID!, $showToClient: Boolean) {
    updateProject(
      projectId: $projectId
      input: { showToClient: $showToClient }
    ) {
      projectId
      showToClient
    }
  }
`;

const ADD_PROJECT_DESCRIPTION = gql`
  mutation($projectId: ID!, $input: ProjectConversationInput) {
    addProjectDescription(projectId: $projectId, input: $input) {
      conversationId
      content
      addedBy {
        userId
        name
        email
      }
      addedOn
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const UPDATE_PROJECT = gql`
  mutation(
    $projectId: ID!
    $title: String
    $status: String
    $scheduledStartDate: String
    $dueDate: String
    $site: SiteInput
    $owner: UserInput
    $addMembers: [UserInput]
    $deleteMembers: [UserInput]
    $isMSPProduct: Boolean!
  ) {
    updateProject(
      projectId: $projectId
      input: {
        title: $title
        status: $status
        scheduledStartDate: $scheduledStartDate
        dueDate: $dueDate
        site: $site
        owner: $owner
        addMembers: $addMembers
        deleteMembers: $deleteMembers
      }
    ) {
      projectId
      displayId
      title
      status
      scheduledStartDate
      dueDate
      overdue
      actualStartDate
      actualEndDate
      client @include(if: $isMSPProduct) {
        accountId
        name
      }
      site {
        id
        name
      }
      owner {
        userId
        name
        firstName
        lastName
        email
      }
      members {
        user {
          userId
          name
          firstName
          lastName
          email
        }
        totalTasks
        completedTasks
        type
      }
      milestones {
        milestoneId
        name
        status
        actualEndDate
        totalTasks
        plannedTasks
        inProgressTasks
        blockedTasks
        completedTasks
        overdueTasks
      }
      totalTasks
      plannedTasks
      inProgressTasks
      blockedTasks
      completedTasks
      overdueTasks
      totalMilestones
      completedMilestones
      loggedInUserRole {
        roleId
        name
        description
        roleType {
          name
        }
        editable
        creationType
        roleFeatureList {
          feature {
            featureId
            key
          }
          operationList {
            operationId
            name
            value
          }
        }
      }
    }
  }
`;

const DELETE_PROJECT = gql`
  mutation($projectId: ID!) {
    deleteProject(projectId: $projectId)
  }
`;

const ADD_PROJECT_COMMENT = gql`
  mutation($projectId: ID!, $input: ProjectConversationInput) {
    addProjectComment(projectId: $projectId, input: $input) {
      conversationId
      content
      addedBy {
        userId
        name
        firstName
        lastName
        email
      }
      addedOn
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const SOFT_DELETE_PROJECTS = gql`
  mutation($ids: [ID]!) {
    softDeleteProjects(ids: $ids)
  }
`;

const HARD_DELETE_PROJECTS = gql`
  mutation($ids: [ID]!) {
    hardDeleteProjects(ids: $ids)
  }
`;

const RESTORE_PROJECTS = gql`
  mutation($ids: [ID]!) {
    restoreProjects(ids: $ids)
  }
`;

export {
  CREATE_PROJECT,
  ADD_PROJECT_DESCRIPTION,
  UPDATE_PROJECT,
  DELETE_PROJECT,
  ADD_PROJECT_COMMENT,
  SOFT_DELETE_PROJECTS,
  HARD_DELETE_PROJECTS,
  RESTORE_PROJECTS,
  UPDATE_SHOW_PROJECT_TO_CLIENT
};
